import { render, staticRenderFns } from "./clothMask.vue?vue&type=template&id=7263bc47&"
import script from "./clothMask.vue?vue&type=script&lang=js&"
export * from "./clothMask.vue?vue&type=script&lang=js&"
import style0 from "./clothMask.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports